module.exports = __webpack_public_path__ + "img/google.3c985d9.png";